const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

const sorted_sizes = ['xxs', 'xxs/xs', 'p', 'xs', 'xs/s', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', 'xl/xxl', 'xxl'];

export const sortBySize = (aVal, bVal) => {
  if (!aVal || !bVal) {
    return 0;
  }

  let aIndex = sorted_sizes.indexOf(aVal.toLowerCase()),
    bIndex = sorted_sizes.indexOf(bVal.toLowerCase());

  if (aIndex < 0 && bIndex < 0) {
    return collator.compare(aVal, bVal);
  }

  if (aIndex < 0) {
    aIndex = sorted_sizes.length;
  } else if (bIndex < 0) {
    bIndex = sorted_sizes.length;
  }

  return aIndex - bIndex;
};

export const variantSort2 = (a, b, order, type, rowA, rowB) => {
  return variantSort(rowA, rowB, order, type);
};

export const variantSort = (a, b, order, type) => {
  const isOptionType = !!a.options[type];

  let aVal = isOptionType ? a.options[type] : a[type];
  let bVal = isOptionType ? b.options[type] : b[type];

  // Flip values if necessary
  if (order === 'asc') {
    [aVal, bVal] = [bVal, aVal];
  }

  const isSizeType = type === 'size' && isNaN(parseInt(aVal, 10));
  if (isSizeType) {
    return sortBySize(aVal, bVal);
  }

  return collator.compare(aVal, bVal);
};
